import { useT } from '@/components/visitone/visitone-provider'
import { PageHeader } from '@/components/visitone/page-header'
import { Card, CardContent } from '@/components/ui/card'

/* Honest placeholder: these destinations are represented in the navigation contract. */
export function PlaceholderSurface({ title }: { title: string }) {
  const t = useT()
  return (
    <div className="flex flex-col gap-4">
      <PageHeader title={title} />
      <Card>
        <CardContent className="flex flex-col items-start gap-1 py-10">
          <p className="text-xs tracking-wide text-fg-muted">
            {t('core.placeholder.eyebrow').toUpperCase()}
          </p>
          <p className="max-w-prose text-sm text-fg">{t('core.placeholder.body')}</p>
        </CardContent>
      </Card>
    </div>
  )
}
